/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliStudentGradeDetailDto } from '../../models/amoxcalli-student-grade-detail-dto';

export interface ApiGradesForParentGet$Plain$Params {
  studentId?: string;
}

export function apiGradesForParentGet$Plain(http: HttpClient, rootUrl: string, params?: ApiGradesForParentGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliStudentGradeDetailDto>>> {
  const rb = new RequestBuilder(rootUrl, apiGradesForParentGet$Plain.PATH, 'get');
  if (params) {
    rb.query('studentId', params.studentId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliStudentGradeDetailDto>>;
    })
  );
}

apiGradesForParentGet$Plain.PATH = '/api/grades/for-parent';
